import * as React from 'react';

// styles
import * as styles from './HeroImage.sass';

export const HeroImage: React.FC = () => <div className={styles.heroImage} />;
